(function() {
  'use strict';

  /* =============================================
   *  CONFIGURAZIONE — MODIFICA QUI
   * ============================================= */

  var DISCOUNT_CODE  = 'A2HYPC2DCDKS';
  var DISCOUNT_LABEL = '7€ di sconto sul tuo prossimo ordine di 69€!';
  var COOKIE_DAYS    = 30;

  // Disclaimer / Termini e condizioni del coupon
  var DISCOUNT_TERMS = 'Coupon valido per un solo utilizzo, '
    + 'su una spesa minima di 69€. Non cumulabile con altri codici sconto. '
    + 'Valido fino al 06/04/2026 23:59.';

  // Tempo in secondi dopo il quale mostrare un aiuto
  // se l'utente ha aperto il widget ma non ha ancora trovato nulla
  var HELP_NUDGE_SECONDS = 120; // 2 minuti

  var EGGS = [
    {
      id: 'egg1',
      selector: '#x-collection-collection_tVUVwC',
      pos: { top: '12px', right: '18px' },
      img: 'https://cdn.shopify.com/s/files/1/0911/3757/3189/files/Uova3.png?v=1773920347',
      name: 'Uovo Smeraldo',
      hint: 'Un ovetto si nasconde tra i <em>prodotti in evidenza</em>... guarda bene tra le varie categorie! 🛍️'
    },
    {
      id: 'egg2',
      selector: '__blog_section__',
      pos: { bottom: '10px', left: '14px' },
      img: 'https://cdn.shopify.com/s/files/1/0911/3757/3189/files/Uova2.png?v=1773920347',
      name: 'Uovo Acquamarina',
      hint: 'Un ovetto si e\' nascosto nella sezione <em>blog</em>, tra gli articoli... scorri e cercalo! 📰'
    },
    {
      id: 'egg3',
      selector: '__footer_col__',
      pos: { top: '6px', right: '10px' },
      img: 'https://cdn.shopify.com/s/files/1/0911/3757/3189/files/Uova.png?v=1773920347',
      name: 'Uovo Dorato',
      hint: 'Un ovetto si e\' infilato giu\' <em>in fondo alla pagina</em>. Scorri fino in basso! 👇'
    }
  ];

  // Modificare qui per cambiare il periodo di attivazione
  var START_DATE = new Date(2026, 3, 1, 0, 0, 0);  // 1 aprile 2026, 00:00
  var END_DATE   = new Date(2026, 3, 6, 23, 59, 59); // 6 aprile 2026, 23:59

  /* =============================================
   *  DA QUI IN POI NON MODIFICARE
   * ============================================= */

  // Solo nel periodo attivo
  var now = new Date();
  if (now < START_DATE || now > END_DATE) return;

  // Solo homepage
  var body = document.body;
  if (!body.classList.contains('index') &&
      !body.classList.contains('template-index') &&
      window.location.pathname !== '/') {
    return;
  }

  // --- Cookie ---
  function setC(n, v, d) {
    var e = new Date();
    e.setTime(e.getTime() + d * 864e5);
    document.cookie = n + '=' + encodeURIComponent(v) +
      ';expires=' + e.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getC(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : null;
  }

  // Stato
  var found = [];
  try { found = JSON.parse(getC('easter_found') || '[]'); } catch(e) { found = []; }
  var isCompleted = getC('easter_done') === '1';
  var total = EGGS.length;

  // Traccia se l'utente ha aperto il widget almeno una volta
  var widgetOpened = false;
  var helpNudgeSent = false;
  var helpTimer = null;

  // --- Trova elemento footer ---
  function findFooterCol() {
    var section = document.querySelector('[id*="__footer"]');
    if (!section) return null;
    return section.querySelector('.footer-col--9');
  }

  // --- Trova elemento blog ---
  function findBlogSection() {
    var el = document.querySelector('[id*="featured_blog"] .x-block-posts');
    if (el) return el;
    return document.querySelector('.x-block-posts.carousel-mobile');
  }

  // --- Trova l'elemento target per un uovo ---
  function findTarget(egg) {
    if (egg.selector === '__footer_col__') return findFooterCol();
    if (egg.selector === '__blog_section__') return findBlogSection();
    return document.querySelector(egg.selector);
  }

  // --- Costruisci indizi HTML per le uova NON ancora trovate ---
  function buildCluesHTML() {
    var clues = [];
    for (var i = 0; i < EGGS.length; i++) {
      if (found.indexOf(EGGS[i].id) !== -1) continue;
      clues.push(EGGS[i].hint);
    }
    if (clues.length === 0) return '';
    var label = clues.length === 1
      ? 'Indizio per l\'ultimo uovo'
      : 'Indizi per le uova restanti';
    var html = '<div class="easter-clue"><strong>' + label + ':</strong><br><br>';
    for (var j = 0; j < clues.length; j++) {
      html += clues[j];
      if (j < clues.length - 1) html += '<br><br>';
    }
    html += '</div>';
    return html;
  }

  // --- Disclaimer HTML ---
  function disclaimerHTML() {
    return '<p class="easter-terms">' + DISCOUNT_TERMS + '</p>';
  }

  // --- Immagine uovo ---
  function eggImg(src) {
    return '<img src="' + src + '" alt="Uovo di Pasqua" ' +
      'style="width:100%;height:100%;object-fit:contain;pointer-events:none;" ' +
      'draggable="false" loading="eager" />';
  }

  // --- Sparkles ---
  function sparkles(x, y) {
    var em = ['✨','⭐','🌿','💚','🥚'];
    for (var i = 0; i < 8; i++) {
      var s = document.createElement('div');
      s.className = 'easter-sparkle';
      s.style.left = (x + (Math.random() - 0.5) * 80) + 'px';
      s.style.top  = (y + (Math.random() - 0.5) * 80) + 'px';
      s.style.fontSize = (16 + Math.random() * 18) + 'px';
      s.textContent = em[Math.floor(Math.random() * em.length)];
      s.style.animationDelay = (Math.random() * 0.3) + 's';
      document.body.appendChild(s);
      setTimeout(function(el) { el.remove(); }, 1200, s);
    }
  }

  // --- Confetti ---
  function confetti() {
    var cols = ['#2ecc71','#1abc9c','#f0c040','#27ae60','#48c9b0','#f5d76e'];
    for (var i = 0; i < 55; i++) {
      var c = document.createElement('div');
      c.className = 'easter-confetti-piece';
      c.style.left = Math.random() * 100 + 'vw';
      c.style.width  = (6 + Math.random() * 8) + 'px';
      c.style.height = (6 + Math.random() * 8) + 'px';
      c.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
      c.style.background = cols[Math.floor(Math.random() * cols.length)];
      c.style.animationDuration = (2 + Math.random() * 3) + 's';
      c.style.animationDelay = (Math.random() * 1.5) + 's';
      document.body.appendChild(c);
      setTimeout(function(el) { el.remove(); }, 6000, c);
    }
  }

  // --- Aggiorna barra counter ---
  function updateBar() {
    var bar = document.querySelector('.easter-bar');
    if (!bar) return;
    bar.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var sp = document.createElement('span');
      if (found.indexOf(EGGS[i].id) !== -1) sp.className = 'easter-filled';
      bar.appendChild(sp);
    }
    var tx = document.querySelector('.easter-count-num');
    if (tx) tx.textContent = found.length + '/' + total;
  }

  // --- Modal ---
  function showModal(html) {
    var ov = document.querySelector('.easter-overlay');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'easter-overlay';
      document.body.appendChild(ov);
    }
    ov.innerHTML = '<div class="easter-modal">' + html + '</div>';
    ov.classList.add('easter-active');

    function close(e) {
      if (e.target === ov || e.target.classList.contains('easter-btn')) {
        ov.classList.remove('easter-active');
        ov.removeEventListener('click', close);
      }
    }
    ov.addEventListener('click', close);
  }

  // --- Mostra il widget info / indizi (click sul counter) ---
  function showWidgetInfo() {
    // Segna che l'utente ha interagito col widget
    if (!widgetOpened) {
      widgetOpened = true;
      startHelpTimer();
    }

    var rem = total - found.length;
    if (rem <= 0) return;

    // Se ha trovato almeno un uovo OPPURE ha già visto il nudge, mostra gli indizi
    var cluesBlock = '';
    if (found.length > 0 || helpNudgeSent) {
      cluesBlock = buildCluesHTML();
    }

    showModal(
      '<span class="easter-modal-icon">🐰</span>' +
      '<h3>Caccia alle Uova di Pasqua!</h3>' +
      '<p>Ci sono <strong>' + total + ' uova</strong> nascoste in questa pagina ' +
      '(solo nella <strong>homepage</strong>). ' +
      'Trovale tutte per sbloccare un <strong>premio speciale</strong>!</p>' +
      '<p style="font-size:14px;color:#2ecc71;font-weight:700">' +
        rem + (rem === 1 ? ' uovo rimasto' : ' uova rimaste') +
      ' da trovare</p>' +
      cluesBlock +
      '<button class="easter-btn">Ho capito! 🔍</button>'
    );
  }

  // --- Timer aiuto: toast non invasiva dopo N secondi ---
  function startHelpTimer() {
    if (helpNudgeSent || found.length > 0) return;

    helpTimer = setTimeout(function() {
      if (found.length > 0 || helpNudgeSent || isCompleted) return;
      helpNudgeSent = true;

      // Crea toast
      var toast = document.createElement('div');
      toast.className = 'easter-toast';
      toast.innerHTML =
        '<div class="easter-toast-inner">' +
          '<span class="easter-toast-icon">🔍</span>' +
          '<div class="easter-toast-body">' +
            '<strong>Serve una mano?</strong>' +
            '<span>Clicca sul widget 🐣 per vedere gli indizi!</span>' +
          '</div>' +
          '<button class="easter-toast-close" aria-label="Chiudi">&times;</button>' +
        '</div>';
      document.body.appendChild(toast);

      // Chiudi al click sulla X
      toast.querySelector('.easter-toast-close').addEventListener('click', function() {
        toast.classList.add('easter-toast-out');
        setTimeout(function() { toast.remove(); }, 400);
      });

      // Chiudi al click ovunque sulla toast (apre il widget)
      toast.querySelector('.easter-toast-inner').addEventListener('click', function(e) {
        if (e.target.classList.contains('easter-toast-close')) return;
        toast.classList.add('easter-toast-out');
        setTimeout(function() { toast.remove(); }, 400);
        showWidgetInfo();
      });

      // Auto-chiudi dopo 8 secondi
      setTimeout(function() {
        if (toast.parentNode) {
          toast.classList.add('easter-toast-out');
          setTimeout(function() { if (toast.parentNode) toast.remove(); }, 400);
        }
      }, 8000);

    }, HELP_NUDGE_SECONDS * 1000);
  }

  // --- Click uovo ---
  function onEgg(egg, el) {
    if (found.indexOf(egg.id) !== -1) return;

    found.push(egg.id);
    setC('easter_found', JSON.stringify(found), COOKIE_DAYS);

    // Se trova un uovo, cancella il timer dell'aiuto
    if (helpTimer) {
      clearTimeout(helpTimer);
      helpTimer = null;
    }

    var r = el.getBoundingClientRect();
    sparkles(r.left + r.width / 2, r.top + r.height / 2);
    el.classList.add('easter-found');
    updateBar();

    if (found.length === total) {
      // TUTTI TROVATI
      setC('easter_done', '1', COOKIE_DAYS);
      isCompleted = true;

      // Aggiorna il counter al modo "trofeo"
      var ctr = document.querySelector('.easter-counter');
      if (ctr) {
        ctr.innerHTML =
          '<span style="font-size:20px">🏆</span>' +
          '<div>' +
            '<div style="font-size:11px;opacity:.6;line-height:1">Il tuo premio</div>' +
            '<div class="easter-bar"></div>' +
          '</div>' +
          '<span class="easter-count-num" style="min-width:28px">' +
            total + '/' + total +
          '</span>';
        var bar = ctr.querySelector('.easter-bar');
        for (var j = 0; j < total; j++) {
          var sp = document.createElement('span');
          sp.className = 'easter-filled';
          bar.appendChild(sp);
        }
        var newCtr = ctr.cloneNode(true);
        ctr.parentNode.replaceChild(newCtr, ctr);
        newCtr.addEventListener('click', showCouponModal);
      }

      setTimeout(function() {
        confetti();
        showCouponModal();
      }, 600);
    } else {
      // Mostra indizi per le uova RESTANTI
      var cluesHTML = buildCluesHTML();
      setTimeout(function() {
        showModal(
          '<span class="easter-modal-icon">🥚</span>' +
          '<h3>' + egg.name + ' trovato!</h3>' +
          '<p>' + found.length + ' di ' + total + ' uova trovate</p>' +
          cluesHTML +
          '<button class="easter-btn">Continua la caccia! 🔍</button>'
        );
      }, 400);
    }
  }

  // --- Piazza un uovo dentro il suo elemento ---
  function placeEgg(egg) {
    if (found.indexOf(egg.id) !== -1) return;

    var target = findTarget(egg);
    if (!target) {
      console.warn('[Easter Hunt] Elemento non trovato per ' + egg.id + ': ' + egg.selector);
      return;
    }

    var cs = window.getComputedStyle(target).position;
    if (cs === 'static' || cs === '') {
      target.style.position = 'relative';
    }

    var el = document.createElement('div');
    el.className = 'easter-egg-anchor';
    el.setAttribute('data-egg', egg.id);

    if (egg.pos.top)    el.style.top    = egg.pos.top;
    if (egg.pos.right)  el.style.right  = egg.pos.right;
    if (egg.pos.bottom) el.style.bottom = egg.pos.bottom;
    if (egg.pos.left)   el.style.left   = egg.pos.left;

    el.innerHTML = eggImg(egg.img);
    el.style.animationDelay = (Math.random() * 2) + 's';

    el.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      onEgg(egg, el);
    });

    target.appendChild(el);
  }

  // --- Mostra il popup col coupon ---
  function showCouponModal() {
    showModal(
      '<span class="easter-modal-icon">🏆</span>' +
      '<h3>Ecco il tuo premio!</h3>' +
      '<p>Hai trovato tutte le uova. Usa questo codice al checkout:</p>' +
      '<div class="easter-discount">' +
        '<small>Il tuo codice sconto</small>' +
        '<span class="easter-code">' + DISCOUNT_CODE + '</span>' +
        '<small>' + DISCOUNT_LABEL + '</small>' +
      '</div>' +
      disclaimerHTML() +
      '<button class="easter-btn">Chiudi 🐰</button>'
    );
  }

  // --- Init ---
  function init() {
    if (document.querySelector('.easter-counter')) return;

    // Se gia' completato: mostra solo il counter con trofeo + click per coupon
    if (isCompleted) {
      var ctr = document.createElement('div');
      ctr.className = 'easter-counter';
      ctr.innerHTML =
        '<span style="font-size:20px">🏆</span>' +
        '<div>' +
          '<div style="font-size:11px;opacity:.6;line-height:1">Il tuo premio</div>' +
          '<div class="easter-bar"></div>' +
        '</div>' +
        '<span class="easter-count-num" style="min-width:28px">' +
          total + '/' + total +
        '</span>';
      document.body.appendChild(ctr);

      var bar = ctr.querySelector('.easter-bar');
      for (var j = 0; j < total; j++) {
        var sp = document.createElement('span');
        sp.className = 'easter-filled';
        bar.appendChild(sp);
      }

      ctr.addEventListener('click', showCouponModal);
      return;
    }

    // Gioco in corso
    var ctr2 = document.createElement('div');
    ctr2.className = 'easter-counter';
    ctr2.innerHTML =
      '<span style="font-size:20px">🐣</span>' +
      '<div>' +
        '<div style="font-size:11px;opacity:.6;line-height:1">Caccia alle uova</div>' +
        '<div class="easter-bar"></div>' +
      '</div>' +
      '<span class="easter-count-num" style="min-width:28px">' +
        found.length + '/' + total +
      '</span>';
    document.body.appendChild(ctr2);

    // Click sul counter: mostra info + indizi persistenti
    ctr2.addEventListener('click', showWidgetInfo);

    for (var i = 0; i < EGGS.length; i++) {
      placeEgg(EGGS[i]);
    }
    updateBar();
  }

  // --- Avvio con retry per elementi lazy (Alpine.js) ---
  function boot() {
    init();

    var retries = 0;
    var retryInterval = setInterval(function() {
      retries++;
      var allPlaced = true;

      for (var i = 0; i < EGGS.length; i++) {
        var egg = EGGS[i];
        if (found.indexOf(egg.id) !== -1) continue;
        if (document.querySelector('[data-egg="' + egg.id + '"]')) continue;
        allPlaced = false;
        placeEgg(egg);
      }

      if (allPlaced || retries >= 5) {
        clearInterval(retryInterval);
      }
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(boot, 500);
    });
  } else {
    setTimeout(boot, 500);
  }

})();